<template>
  <div class="member_container">
    <!-- 头部卡片： -->
    <div class="header_card">
      <!-- 情况一：&&&&&&&&&&&&&&&没有登录： -->
      <div class="header_card_inner no_login" v-if="!isLogin">
        <h2 class="badge">达人荟</h2>
        <p class="desc">{{$t('Member.joinMembers')}}</p>
        <div class="btn_box" @click="loginOpen = true">{{$t('Member.loginAndRegister')}}</div>
      </div>
      <!-- 情况二：&&&&&&&&&&&&&&&已经登录：且是会员 -->
      <div class="header_card_inner is_login" v-else-if="isLogin && Boolean(userInfo.isLoyalty)">
        <div class="is_login_header">
          <h2 class="badge">达人荟</h2>
          <div class="streamer">
            <div class="streamer_inner" v-if="this.lang=='zh'">
              <!-- <span class="highlight m_r4">{{_comingOverPointDateAgain}}</span> -->
              <span class="highlight m_lr4">{{ comingOverPointTime}}</span>
              <span>{{$t('Member.thereWillBe')}}</span>

              <span class="highlight m_lr4">{{ comingOverPoint ? comingOverPoint : 0 }}</span>
              <span>{{$t('Member.integral')}}{{$t('Member.overdue')}}</span>
            </div>
            <div class="streamer_inner" v-else>
              <span class="highlight m_lr4">{{userInfo.comingOverPoint? userInfo.comingOverPoint: 0}}</span>
              <span>points is due on </span>
              <span class="highlight m_r4 paddingLeft6"> {{_comingOverPointDateAgain}}</span>
            </div>
          </div>
        </div>
        <div class="is_login_body">
          <div class="is_login_body_left">
            <div class="is_login_body_left_top">
              <div class="is_login_body_left_top_left">
                <img
                  :src="userInfo.headerUrl? myNormalizeImg(userInfo.headerUrl): require('../../assets/img/empty/wait.png')"
                  alt="头像" />
              </div>
              <div class="is_login_body_left_top_right">
                <Tooltip placement="bottom" max-width="300" :content="lang_hello">
                  <h3>{{lang_hello}}</h3>
                </Tooltip>
                <p>{{$t('Member.cardNumber')}}：{{cellPhone? cellPhone: '- -'}}</p>
              </div>
            </div>
            <div class="is_login_body_left_bottom">
              <div class="is_login_body_left_bottom_left">
                <span class="iconfont icon-jinbi"></span>
              </div>
              <div class="is_login_body_left_bottom_right">
                <p class="is_login_body_left_bottom_right_to_point" @click="pointInfo">
                  <span class="count">{{userInfo.userfulPoint? userInfo.userfulPoint: 0}}</span>
                  {{$t('Member.availableIntegral')}}
                  <span class="iconfont icon-xiala1"></span>
                </p>
                <p>{{$t('Member.deductible')}} <span
                    style="font-size: 18px; font-weight: bold;">{{userInfo.pointDeductionMoney?
                    userInfo.pointDeductionMoney: 0}}</span> {{$t('Member.yuan')}}，{{$t('Member.des')}}</p>
              </div>
            </div>
          </div>
          <div class="is_login_body_right">
            <!-- 进度条： -->
            <div class="bar_box">
              <!-- 三等级的节点： -->
              <div class="bar_inner_one" data-text="初享" :class="{'active': identityAgain === '1' }"></div>
              <div class="bar_inner_two" data-text="心享" data-pointer="300" :class="{'active': identityAgain === '2' }">
              </div>
              <div class="bar_inner_three" data-text="尊享" data-pointer="1000"
                :class="{'active': identityAgain === '3' }"></div>
              <!-- 奔跑的man： -->
              <!-- <div class="bar_man" ref="barMan" :style="{left: progress * 100 > 40? progress * 10000 * 80  / 10000 + '%': progress * 100 + '%'}"> -->
              <div class="bar_man" ref="barMan" :style="{left: progress * 100 + '%'}">
                <div> <img src="../../assets/img/member/barman_pao.png" alt=""> </div>
                <div></div>
                <!-- 升级仅需多少积分： -->
                <div class="bar_man_top_text" v-if="userLevel == 1">
                  还需 {{(levelChangeType === 'upgrade' ? needPoint : userInfo.becomeVipNeedPoint) || 0 }} 升至心享
                </div>

                <div class="bar_man_top_text" v-if="userLevel == 2">
                  还需 {{ (levelChangeType === 'upgrade' ? needPoint : userInfo.becomeVipNeedPoint) || 0 }} 升至尊享
                </div>


                <div class="bar_man_bottom_text" v-if="userLevel == 2 || userLevel == 3">{{this.lang !==
                  "zh"?$t('Member.gradeOverdue'):''}}{{overVipTimeAgain | formatTime(this.lang === "zh"?
                  "yyyy年mm月dd日":
                  "yyyy/mm/dd")}}{{this.lang === "zh"?$t('Member.gradeOverdue'):''}}</div>
                <!---保级仅需多少积分：-->
                <div v-if="userLevel == 3" class="bar_man_top_text">
                  还需 {{ (levelChangeType === 'renewal' ? needPoint : userInfo.becomeVipNeedPoint) || 0 }} 积分可保级</div>
              </div>
              <!-- 进度背景色： -->
              <!-- <div class="bar_bgc" ref="barBgc" :style="{width: progress * 100 > 40? progress * 10000 * 80  / 10000 + '%': progress * 100 + '%'}"></div> -->
              <div class="bar_bgc" ref="barBgc" :style="{width: progress * 100 + '%'}"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 情况三：&&&&&&&&&&&&&&&&已经登录，不是会员： -->
      <div class="header_card_inner no_login" v-else-if="isLogin && !Boolean(userInfo.isLoyalty)">
        <h2 class="badge">达人荟</h2>
        <p class="desc">{{$t('Member.joinMembers')}}</p>
        <div class="btn_box" @click="joinMemberImmediately()">{{$t('Member.immediatelyToJoin')}}</div>
      </div>
    </div>
    <!-- 主体部分： -->
    <div class="body_card">
      <!-- 主体导航： -->
      <div class="body_card_nav">
        <div class="body_card_nav_inner">
          <!-- 引入核心滚动start: -->
          <div class="horizontal-container">
            <div class="scroll-wrapper" ref="scroll">
              <div class="scroll-content">
                <div class="body_card_nav_item" v-for="item in navList" :key="item.id"
                  :class="{'active': whoHighLight === item.id}" @click="nvaClick(item)">{{lang === 'zh'? item.title:
                  item.titleEN}}</div>
              </div>
            </div>
          </div>
          <!-- 引入核心滚动end -->
        </div>
      </div>
      <!-- 主体内容： -->
      <div class="body_card_content">
        <router-view></router-view>
      </div>
    </div>
    <w-login :loginOpen="loginOpen" @LoginClose="LoginClose"></w-login>
    <join-immediately :dialogFlag="needPerfectionBoxFlag" @hideMask="cancelDelete"></join-immediately>
    <transition name="myself-dialog-fade">
      <div class="showBox_father" v-if="dialogFlag">
        <div v-if="!isNewMember" class="showBox_son" :class="memberBg">
          <div class="member-btns">
            <a class="member-btn-box" @click="goBtnLink('/menu')">去订餐</a>
            <a class="member-btn-box" v-if="couponBtnStatus" @click="goBtnLink('/mine/card')">查看卡券包</a>
            <a class="member-btn-box" v-if="memberBtnStatus" @click="goBtnLink('/member/special')">会员权益</a>
          </div>
          <div class="closeIcon iconfont icon-2guanbi" @click="closeDialog"></div>
        </div>
        <div v-if="isNewMember == '1'" class="showBox_son xhytq-bg" style="width: 461px; height: 416px;"
          @click="goExchange">
          <img :src="xhytqUImg" alt="">
          <div class="closeIcon iconfont icon-2guanbi" @click.stop="closeDialog"></div>
        </div>
        <div v-if="isNewMember == '2'" class="showBox_son xhydh-bg" style="width: 436px; height: 424px;"
          @click="goBtnLink('/mine/card')">
          <img :src="xhydhImg" alt="">
          <div class="closeIcon iconfont icon-2guanbi" @click.stop="closeDialog"></div>
        </div>
      </div>
    </transition>

    <msg-log ref="msgDialog" @refreshInfo="getUserDetail"></msg-log>
  </div>
</template>

<script>
import { mapActions, mapState,mapMutations,mapGetters  } from "vuex";
import { Toast } from "vant";
import wlogin from "@components/login/login";
// better scroll:
import BScroll from '@better-scroll/core'
import date from '@/utils/date';
import userStore from "@/store/userStore/userStore.js";
import appStore from '@store/app.store.js';
import normalizeImg from '@extend/filters/app/normalizeImg';
import JoinImmediately from './../../components/joinImmediately/joinImmediately.vue';
import {Base64} from "js-base64";
import moment from 'moment';
// 短信营销弹窗
import msglog from '../Home/Msg_log.vue';
export default {
  name: "member",
  components: {
    'w-login': wlogin,
    JoinImmediately,
    'msg-log': msglog,
  },
  filters: {
    formatTime(val, format) {
      //转换年月日方法
      const getDate = (format, str) => {
        let oTime = "";
        var oDate = new Date(str),
            oYear = oDate.getFullYear(), 
            oMonth = oDate.getMonth() + 1,  
            oDay = oDate.getDate(),
            oHour = oDate.getHours(),  
            oMin = oDate.getMinutes(),
            oSec = oDate.getSeconds();
        if(format == 'yyyy-mm-dd') {
          oTime = oYear + '-' + getzf(oMonth) + '-' + getzf(oDay);
        } else if (format == 'yyyy/mm/dd') {
         	oTime = oYear + '/' + getzf(oMonth) + '/' + getzf(oDay);
        } else if (format == 'yyyy年mm月dd日') {
          oTime = `${oYear}年${getzf(oMonth)}月${getzf(oDay)}日`;
        }
        return oTime;  
      };
      const getzf = (num) => {
        if(parseInt(num) < 10){  
          num = '0' + num;  
        }  
        return num;  
      }
      let result = getDate(format, val);
      return result;
    }
  },
  data() {
    return {
      navList: [
        {
          title: "本期主打",
          titleEN: "What’s New",
          id: 0,
          whoCom: 'membercurrentperiod'
        },
        {
          title: "会员特权",
          titleEN: "Membership Privileges",
          id: 1,
          whoCom: "memberspecial"
        },
        // {
        //   title: "积分商城",
        //   titleEN: "integral market",
        //   id: 2,
        //   whoCom: "memberintegralmarket"
        // },
        // {
        //   title: "宝贝厨房",
        //   titleEN: "baby kitchen",
        //   id: 3,
        //   whoCom: "memberbabykitchen"
        // },
        {
          title: "积分攻略",
          titleEN: "Tips on Points",
          id: 4,
          whoCom: "memberintegralstrategy"
        },
        {
          title: "积分明细",
          titleEN: "Points detail",
          id: 5,
          whoCom: "memberintegraldetail"
        },
        {
          title: "会员章程",
          titleEN: "Membership constitution",
          id: 6,
          whoCom: "memberconstitution"
        }
      ],
      whoHighLight: 0,
      loginOpen: false,
      immediatelyVisible: false, // 立即入会弹窗
			needPerfectionBoxFlag: false, //提示完善地址弹框标识
      dialogFlag: false,
      couponBtnStatus: false, // 去卡券
      memberBtnStatus: false, // 去会员特权
      memberBg: '', // 会员弹窗背景图片
      isMember: false, //是否是会员
      isNewMember: '1', //1新会员兑换弹窗，2兑换成功弹窗，''升级礼
      cellPhone:null,
      xhytqUImg:null,//新入会
      xhydhImg:null, //入会
      isGrayPage: false, //页面是否置灰
      completeInfoed: false, //用户是否完善信息
      userId: '', //用户id
      levelChangeType: 'upgrade', //用户下一等级是升级还是保级renewal
      needPoint: 0, //升级或保级所需积分
      comingOverPoint:null, //即将过期积分
      comingOverPointTime:null, //即将过期积分时间
    };
  },
  computed: {
    overVipTimeAgain() {
      return this.userInfo.overVipTime ? this.userInfo.overVipTime: Date.now() + 1000 * 60 * 60 * 24 * 3
    },
    identityAgain() {
      let result = '';
      // 获取用户身份等级
      this.userInfo.asUserGradeMessage && this.userInfo.asUserGradeMessage.forEach(item => {
        if (item.type === this.userInfo.loyaltyLevel) {
          if (item.typeName.includes('初享')) {
            result = '1';
          } else if (item.typeName.includes('心享')) {
            result = '2';
          } else if (item.typeName.includes('尊享')) {
            result = '3';
          }
        }
      });
      return result;
    },
    isLogin() {
      return userStore.getters.isLogin;
    },
    userInfo() {
      return userStore.getters.userInfo;
    },
    lang() {
      return this.$i18n.locale;
    },
    lang_hello() {
      return  (this.userInfo.name || this.userInfo.nickName || this.userInfo.cellPhone ? this.userInfo.cellPhone.toString().slice(0, 3)+ '****'+ this.userInfo.cellPhone.toString().slice(-4):'亲爱的会员');
    },
    sessionId() {
      return localStorage.getItem('__user_token') || ''
    },
    // 进度
		progress() {
      // way one:
      // const oneIntegral = 1000;
      // const integral = this.userInfo.userfulPoint;
      // let res = integral / oneIntegral;
      // res = res * 100 > 125? 1.25: res; 
      // return res;
      // way two:
      let res = 0;
      switch (this.userLevel) {
        case 0:
        case '0':
          res = 0;
          break;
        case 1:
        case '1':
          res = 0.1;
          break;
        case 2:
        case '3':
          res = 0.3;
          break;
        case 3:
        case '3':
          res = 0.8;
          break;
      }
      return res;
    },
    _comingOverPointDateAgain() {
      if (this.lang === 'zh') {
        return this.userInfo.comingOverPointTime? date.date.formatTime(+new Date(this.userInfo.comingOverPointTime.replace(/-/g,'/'))).a: "";
      } else {
        return this.userInfo.comingOverPointTime? date.date.formatTime(+new Date(this.userInfo.comingOverPointTime.replace(/-/g,'/'))).c: "";
      }
    },
    userLevel(){
        return this.userInfo.loyaltyLevel;
    },
  },
  mounted() {
    this.refreshHighLight();
    // 初始化滚动：
    this.init();
    this.getStoreInfo().then(storeInfo => {
      if (this.isLogin) {
        this.getUserDetail();
        this.getAsUsercompleteInfoFn();
        this.getUserByIdOnlyUserInfo();
      }
    })
    this.getTemplateByGroup();
    // appStore.dispatch('getPageGrayInfo', "member").then(isGray => {
    //   this.isGrayPage = isGray;
    // });
  },
  watch: {
    "$route.path": function() {
      this.refreshHighLight();
    }
  },
  methods: {
    myNormalizeImg(img) {
      return normalizeImg.fn(img);
    },
    ...mapActions("addressStore", {
      getStoreInfo:"getStoreInfo", //获取门店地址
    }),
    
    //获取用户信息
    getUserDetail() {
      this.$get('getUserDetail',{encodedPhone: 'ok', pageFlag:'memberCenter' }).then(res => {
        if (res.data.errCode !== '00') {
          Toast(res.data.errMsg);
          return;
        }
        // if (res.data.data.cellPhone && !/^\d+$/.test(res.data.data.cellPhone)) {
        //   res.data.data.cellPhone = Base64.decode(decodeURIComponent(res.data.data.cellPhone))
        //       }
        if (res.data.data.cellPhone && !/^\d+$/.test(res.data.data.cellPhone)) {
                let cellPhoneData = Base64.decode(decodeURIComponent(res.data.data.cellPhone));
                res.data.data.cellPhone = cellPhoneData.toString().slice(0, 3)+ '****'+ cellPhoneData.toString().slice(-4);
                this.cellPhone = res.data.data.cellPhone
             }
        this.userInfoDetail = res.data.data;
        this.isMember = this.userInfoDetail.loyaltyLevel >= 1 ? true : false
        userStore.commit('setUserInfo', this.userInfoDetail);
        userStore.commit("setUserKey", this.userInfoDetail.userKey);
        // console.log('getUserDetail', this.userInfoDetail);

        // 首先弹出营销短信弹窗;
        // 设置短信营销标识位
        if(this.userInfoDetail.personalizedShowTag){
          localStorage.setItem('personalizedShowTag', this.userInfoDetail.personalizedShowTag)
          this.$refs.msgDialog.modalMsg = true;
          return;
        }else{
          let personalizedShowTag = localStorage.getItem('personalizedShowTag');
          if(personalizedShowTag){
            localStorage.removeItem('personalizedShowTag');
          }
        }

        if(this.isMember && !this.userInfoDetail.popupType && !this.userInfoDetail.upgradeGifts && this.userInfoDetail.isPopup == 1){
          this.isNewMember = '1'
          this.dialogFlag = true;
          this.clearPopup();
        }else{
          this.levelLog();
        }
        
      }).catch(err => console.error(err));
    },
    //获取用户完善信息
    getAsUsercompleteInfoFn() {
      this.$get('getPointBySessionId').then(res => {
        if (res.data.errCode !== '00') {
          Toast(res.data.errMsg);
          return;
        }
        this.completeInfoed = res.data.data.fullInfoFlag || false;
        this.levelChangeType = res.data.data.levelChangeType;
        this.needPoint = res.data.data.needPoint;

      }).catch(err => console.error(err));
    },
    //获取即将过期积分
    getUserByIdOnlyUserInfo() {
      this.$get('getUserByIdOnlyUserInfo').then(res => {
        if (res.data.errCode !== '00') {
          Toast(res.data.errMsg);
          return;
        }
        this.comingOverPoint = res.data.data.comingOverPoint || 0;
        this.comingOverPointTime = res.data.data.comingOverPointTime ? this.$moment(res.data.data.comingOverPointTime).format('YYYY-MM-DD') : '';
      

      }).catch(err => console.error(err));
    },
    levelLog(){
        // couponBtnStatus-去卡券 memberBtnStatus-去会员特权 memberBg-会员弹窗背景图片
        // popupType 1:新入会, 2:L1升L2, 3:L2保级L2, 4:L1升级L3, 5:L2升级L3, 6:L3保级L3
        // isFirstChangeLevel  true:首次升级/保级,false:非首次升级/保级
        
        this.isNewMember = '';
        switch(this.userInfoDetail.popupType) {
          case 1:
            this.memberBg = 'cxdr-bg';
            this.couponBtnStatus = true;
            this.dialogFlag = true;
            break;
          case 2:
            this.memberBg = 'xxdr-sj-bg';
            this.userInfoDetail.isFirstChangeLevel ? this.couponBtnStatus = true : this.memberBtnStatus = true;
            this.dialogFlag = true;
           break;
          case 3:
            this.memberBg = 'xxdr-bj-bg';
            this.memberBtnStatus = true;
            this.dialogFlag = true;
            break;
          case 4:
            this.memberBg = 'zxdr-sj-bg';
            this.userInfoDetail.isFirstChangeLevel ? this.couponBtnStatus = true : this.memberBtnStatus = true;
            this.dialogFlag = true;
            break;
          case 5:
            this.memberBg = 'zxdr-sj-bg';
            this.memberBtnStatus = true;
            this.dialogFlag = true;
            break;
          case 6:
            this.memberBg = 'zxdr-bj-bg';
            this.memberBtnStatus = true;
            this.dialogFlag = true;
            break;
        };
    },
    CDP(text) {
      try {
        clab_tracker.ready(function(){
          this.track('c_click_topbutton', {'c_buttonname': text, "title": text, "targetName": text});
          setTimeout(()=>{
            this.track("open_page", { "title": text, "targetName": text });
          }, 1000)
        });
      } catch (error) {
        
      }
    },
    pointInfo() {
      this.$router.push({name: 'memberintegraldetail'})
      this.CDP('积分明细');
    },
    nvaClick(val) {
      this.whoHighLight = val.id;
      this.$router.push({name: val.whoCom});
    
      this.CDP(val.title);
    },
    refreshHighLight() {
      this.navList.some(item => {
        if (this.$route.name.includes(item.whoCom)) {
          this.whoHighLight = item.id;
          return true;
        }
      })
    },
    LoginClose(flag) {
      this.loginOpen = flag;
    },
    // 核心滚动 start:
    init() {
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        probeType: 3 // listening scroll hook
      })
      this._registerHooks(['scroll', 'scrollEnd'], (pos) => {
        // console.log('done');
      })
    },
    _registerHooks(hookNames, handler) {
      hookNames.forEach((name) => {
        this.bs.on(name, handler)
      })
    },
    // 核心滚动 end
    // 加入会员：
    joinMemberImmediately() {
      // this.$router.push({name: "memberjoinimmediately"});
     
      this.immediatelyVisible = true
			this.needPerfectionBoxFlag = true
    },
    cancelDelete() {
			this.needPerfectionBoxFlag = false
    },
    closeDialog() {
      this.dialogFlag = false;
    },
    clearPopup() {
      this.$post('user/user/clearPopup',{ popupFlag: 1 }).then(res => {
        if (res.data.errCode !== '00') {
          // console.log('clearPopup', res);
        }
      }).catch(err => console.error(err));
    },
    goBtnLink(type) {
      this.dialogFlag = false;
      this.$router.push(type);
    },
    goExchange(){
      this.$post('user/user/exchangeCoupon').then(res => {
        if (res.data.errCode !== '00') {
          Toast(res.data.errMsg);
          return;
        }else{
          this.isNewMember = '2';
        }
      })
    },
    // 会员中心新会员特权弹框
     getTemplateByGroup() {
        this.$post("getTemplateByGroup",{
          group: 'mc_newmemberpopup'
        })
        .then(res => {
          if(res.data.code == 200){
         this.xhytqUImg =res.data && res.data.data[0] && res.data.data[0].temButton.button1Icon || '';
         this.xhydhImg =res.data && res.data.data[0] && res.data.data[0].temButton.button2Icon || '';
         
          }
        },err => {
          console.log('err'. err)
        });
      },
  },
  beforeDestroy() {
    this.bs.destroy();
  },

};
</script>

<style lang="scss" scoped>
.isGray {
	 filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
     -webkit-filter: grayscale(100%);
     filter: grayscale(100%);
}
.member_container {
  position: relative;
  .header_card {
    width: 100%;
    height: 250px;
    padding: 20px;
    padding-bottom: 0px;
    .header_card_inner {
      width: 100%;
      height: 100%;
      background-image: url(../../assets/img/member/bgc.png);
      background-size: 400px 250px;
      background-repeat: repeat-x;
      border-radius: 25px 25px 0 0;
      &.no_login {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .badge {
          padding: 10px 30px;
          background-image: linear-gradient(to right, #E8CFA7, #FAE7C6, #D6B68B, #ECD3AC);
          border-radius: 5px;
          letter-spacing: 3px;
          color: #000;
        }
        .desc {
          margin: 15px 0 30px;
        }
        .btn_box {
          padding: 10px 30px;
          background-color: $theme_red;
          box-shadow: 0 0 5px $theme_red;
          border-radius: 25px;
          color: #fff;
          cursor: pointer;
          &:hover {
            background-color: rgb(155, 4, 9);
          }
        }
      }
      &.is_login {
        text-align: left;
        display: flex;
        flex-direction: column;
        .is_login_header {
          height: 35px;
          position: relative;
          .badge {
            width: 150px;
            height: 55px;
            border-radius: 5px;
            text-align: center;
            background-image: linear-gradient(to right, #E8CFA7, #FAE7C6, #D6B68B, #ECD3AC);
            color: #100F0B;
            letter-spacing: 3px;
            position: absolute;
            left: 0;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .streamer {
            width: 350px;
            height: 40px;
            position: absolute;
            right: 0;
            top: 0;
            line-height: 40px;
            padding-left: 50px;
            color: #FFF;
            background-image: url(../../assets/img/member/streamer_bgc.png);
            background-size: 100% 100%;
            .streamer_inner {
              width: 300px;
              height: 40px;
              display: flex;
              justify-content: center;
            }
            .highlight {
              font-size: 18px;
              color: #FFF205;
            }
          }
        }
        .is_login_body {
          flex: 1;
          display: flex;
          padding-top: 12px;
          .is_login_body_left {
            width: 350px;
            height: 100%;
            display: flex;
            flex-direction: column;
            .is_login_body_left_top {
              flex: 4;
              display: flex;
              align-items: flex-end;
              padding-left: 30px;
              .is_login_body_left_top_left {
                width: 90px;
                height: 90px;
                border-radius: 50%;
                margin-right: 15px;
                border: 1px solid #A76408;
                box-shadow: 1px 1px 10px #C89957;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 50%;
                }
              }
              .is_login_body_left_top_right {
                flex: 1;
                color: #A76408;
                height: 55px;
                margin-bottom: 5px;
                h3 {
                  width: 160px;
                  height: 30px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                p {
                  height: 25px;
                  font-size: 14px;
                }
              }
            }
            .is_login_body_left_bottom {
              flex: 3;
              padding-left: 40px;
              display: flex;
              .is_login_body_left_bottom_left {
                margin-right: 10px;
                .iconfont {
                  font-size: 45px;
                  color: #e47d07;
                }
              }
              .is_login_body_left_bottom_right {
                flex: 1;
                p:nth-of-type(1) {
                  margin-top: 10px;
                  background-color: #e47d07;
                  width: 170px;
                  border-radius: 10px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: #fff;
                  font-size: 12px;
                  cursor: pointer;
                  .count {
                    margin-right: 7px;
                    font-size: 18px;
                  }
                  .iconfont {
                    margin-left: 7px;
                    font-size: 12px;
                  }
                }
                p:nth-of-type(2) {
                  color: #e47d07;
                  font-size: 12px;
                }
              }
            }
          }
          .is_login_body_right {
            flex: 1;
            display: flex;
            align-items: center;
            padding-left: 20px;
            .bar_box {
              width: 85%;
              height: 18px;
              border: 2px solid #E3C794;
              border-radius: 5px;
              position: relative;
              .bar_inner_one,
              .bar_inner_two,
              .bar_inner_three {
                height: 40px;
                width: 1px;
                border-left: 2px solid #E3C794;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                z-index: 1;
                &.active {
                  &::before {
                    font-size: 18px;
                    font-weight: bold;
                  }
                }
                &::before,
                &::after {
                  width: 40px;
                  height: 30px;
                  position: absolute;
                  left: -22px;
                  display: flex;
                  justify-content: center;
                  font-size: 14px;
                  color: #A8640B;
                }
                &::before {
                  bottom: -40px;
                }
                &::after {
                  top: -30px;
                }
              }
              .bar_inner_one,
              .bar_inner_two,
              .bar_inner_three {
                &::before,
                &::after {
                  color: #AB6A11;
                  font-weight: bold;
                }
              }
              .bar_inner_one {
                left: 10%;
                &::before {
                  content: attr(data-text);
                }
              }
              .bar_inner_two {
                left: 30%;
                &::before {
                  content: attr(data-text);
                }
                &::after {
                  content: attr(data-pointer);
                  display: none;
                }
              }
              .bar_inner_three {
                left: 80%;
                &::before {
                  content: attr(data-text);
                }
                &::after {
                  content: attr(data-pointer);
                  display: none;
                }
              }
              .bar_man {
                position: absolute;
                left: 0; //动态
                top: -20px;
                width: 80px;
                height: 50px;
                display: flex;
                z-index: 2;
                position: relative;
                transition: left 0.5s;
                transform: translateX(-25px);
                .bar_man_top_text,
                .bar_man_bottom_text {
                  width: 240px;
                  position: absolute;
                  left: 50%;
                  transform: translateX(-55%);
                  text-align: center;
                  font-size: 12px;
                }
                .bar_man_top_text {
                  top: -40px;
                  color: #413B33;
                }
                .bar_man_bottom_text {
                  bottom: -60px;
                  color: #D20107;
                }
                > div:nth-of-type(1) {
                  width: 50px;
                  height: 50px;
                  float: left;
                  background-color: #000;
                  border: 3px solid #D4BA8B;
                  border-radius: 25px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  img {
                    width: 33px;
                  }
                }
                > div:nth-of-type(2) {
                  width: 30px;
                  height: 50px;
                  float: left;
                  background-image: url(../../assets/img/member/arrow.png);
                  background-repeat: no-repeat;
                  background-position: -30px 1px;
                  background-size: 60px 50px;
                }
              }
              .bar_bgc {
                position: absolute;
                left: 0;
                bottom: 0;
                height: 14px;
                width: 0; //动态
                background-image: url(../../assets/img/member/bar_bgc.png);
                background-size: 35px 16px;
                border-radius: 5px 0 0 5px;
                transition: width 0.5s;
                animation: backgroundposition 30s linear 0s infinite;
              }
            }
          }
        }
      }
    }
  }
  @keyframes backgroundposition {
    from {
      background-position: 0px 0px;
    }
    to {
      background-position: 1000px 0px;
    }
  }
  .body_card {
    width: 100%;
    .body_card_nav {
      height: 40px;
      background-color: #ffe6c4;
      padding: 0 100px;
      .body_card_nav_inner {
        width: 100%;
        height: 100%;
        .horizontal-container {
          width: 100%;
          height: 100%;
          .scroll-wrapper {
            width: 100%;
            height: 100%;
            white-space: nowrap;
            overflow: hidden;
          }
          .scroll-content {
            height: 100%;
            display: inline-block;
          }
          .body_card_nav_item {
            padding: 0 20px;
            height: 100%;
            display: inline-block;
            font-size: 16px;
            line-height: 40px;
            cursor: pointer;
            &.active {
              color: #fff;
              background-color: #f4dab5;
              border-bottom: 2px solid #8e6924;
            }
          }
        }
      }
    }
  }
  .showBox_father {
    @include showBoxFather();
    .showBox_son {
      display: flex;
      width: 741px;
      height: 386px;
      position: absolute;
      @include AnyElementCentered();
      flex-direction: column;
      position: relative;
      border-radius: 10px;
      z-index: 15;
        .closeIcon {
          position: absolute;
          bottom: -80px;
          left: 50%;
          font-size: 30px;
          transform: translateX(-50%);
          color: #fff;
        }
        .member-btns {
          display: flex;
          width: 65%;
          margin: 250px auto 0;
          justify-content: space-between;
          .member-btn-box {
            width: 224px;
            height: 64px;
            line-height: 64px;
            text-align: center;
            color: #000;
            font-size: 22px;
          }
        }
    }
    .cxdr-bg {
      background: url('../../assets/img/member/cxdr_bg.png');

      .member-btn-box {
        background: url('../../assets/img/member/member_ys_btn.png');
      }
    }
    .xxdr-sj-bg {
      background: url('../../assets/img/member/xxdr_sj_bg.png');

      .member-btn-box {
        background: url('../../assets/img/member/member_yellow_btn.png');
      }
    }
    .xxdr-bj-bg {
      background: url('../../assets/img/member/xxdr_bj_bg.png');

      .member-btn-box {
        background: url('../../assets/img/member/member_yellow_btn.png');
      }
    }
    .zxdr-sj-bg {
      background: url('../../assets/img/member/zxdr_sj_bg.png');

      .member-btns .member-btn-box {
        color: #fff;
        background: url('../../assets/img/member/member_red_btn.png');
      }
    }
    .zxdr-bj-bg {
      background: url('../../assets/img/member/zxdr_bj_bg.png');

      .member-btns .member-btn-box {
        color: #fff;
        background: url('../../assets/img/member/member_red_btn.png');
      }
    }
    .xhytq-bg{
      // background: url('../../assets/img/member/xhytq_bg.png') no-repeat;
      background-size: 100% 100%;
    }
    .xhydh-bg{
      // background: url('../../assets/img/member/xhydh_bg.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
